/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseTextarea from 'shared/ui/components/form-components/BaseTextarea.vue';

const __vue_script__ = {
    name: 'RequirementsPicker',

    components: { BaseTextarea },

    extends: BaseControl,

    props: {

        value: {
            type: Array,
            default: () => [],
        }
    },

    computed: {
        localValues: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
    },

    methods: {
        /**
         * @param {string} label
         * @param {number} index
         */
        onChange(label, index) {
            this.localValues[index] = { label };
        },

        /** @type {(index: number) => () => void} */
        onDelete(index) {
            this.localValues = this.localValues.filter((_, i) => i !== index);
        },

        onAdd() {
            this.localValues.push({ label: '' });
        },
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{staticClass:"requirements-picker",attrs:{"label":_vm.label,"tip":_vm.tip,"hint":_vm.hint,"uid":_vm.uid,"errors":_vm.errors,"warning":_vm.warning,"hint-after-label":_vm.hintAfterLabel,"dependant":_vm.dependant}},[_vm._l((_vm.localValues),function(ref,index){
var label = ref.label;
return _c('div',{staticStyle:{"display":"grid","grid-template-columns":"1fr auto","column-gap":".5em"}},[_c('base-textarea',{attrs:{"name":("item-" + index),"value":label,"rows":1},on:{"input":function($event){return _vm.onChange($event, index)}}}),_c('div',[_c('button',{staticClass:"btn btn-danger btn-icon single",on:{"click":function($event){$event.preventDefault();return _vm.onDelete(index)}}},[_c('i',{staticClass:"ic-x"})])])],1)}),_c('button',{staticClass:"btn btn-primary btn-icon single",on:{"click":function($event){$event.preventDefault();return _vm.onAdd.apply(null, arguments)}}},[_c('i',{staticClass:"ic-plus"})])],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "RequirementsPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__